export default "__VITE_ASSET__DJw49ULf__"